import { DatabaseService, Vendor, VendorData, VendorRepository } from "@/core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getVendorRepository(
  databaseService: DatabaseService,
): VendorRepository {
  return getGenericRepository<Vendor, VendorData>(
    () => DatabaseCollection.VENDORS,
    databaseService,
  );
}
